module.exports = __webpack_public_path__ + "static/img/005yanjing-3.a50606b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/005yanjing-3.png
// module id = 1zmu
// module chunks = 5